/* unplugin-vue-components disabled */import script from "./NavMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavMenuItem.vue?vue&type=script&setup=true&lang=ts"

import "./NavMenuItem.vue?vue&type=style&index=0&id=09a5b21b&scoped=true&lang=less"

import exportComponent from "D:\\workspace\\home-power-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09a5b21b"]])

export default __exports__